import {Component, OnInit} from '@angular/core';
import {UsanaObject} from "../../usana-object";
import {LoggerService} from "../../common/logger.service";
import {IMPGalleryCards, IMPGalleryCardSubModule} from "../marketing-page.models";
import {MarketingPageUtil} from "../marketing-page-util";
import {TranslateService} from "../../translation/translate.service";

@Component({
    templateUrl: './gallery-cards.component.html',
    styleUrls: ['./gallery-cards.component.scss'],
    standalone: false
})
export class GalleryCardsComponent extends UsanaObject implements OnInit {

    pageUrl: string;
    componentData: IMPGalleryCards;
    useLocaleOverride: boolean;
    backgroundColor: string;
    subCards: IMPGalleryCardSubModule[] = [];
    componentStyle: string;
    title: string;

    constructor(
        loggerService: LoggerService,
        private translationService: TranslateService
    ) {
        super(
            loggerService
        );
    }

    ngOnInit(): void {
        this.backgroundColor = MarketingPageUtil.getBackgroundColor(this.componentData.backgroundColor);
        this.subCards = this.componentData.children;
        const titleTranslationTag = `${MarketingPageUtil.getTranslationRoot(this.pageUrl, this.componentData.name)}.title`;
        this.translationService.translate(titleTranslationTag, this.useLocaleOverride).then((translation: string) => {
            if (translation !== titleTranslationTag) {
                this.title = translation;
            }
        });

        if (this.componentData.componentStyle) {
            this.componentStyle = this.componentData.componentStyle;
        }
    }
}
